// extracted by mini-css-extract-plugin
export var image = "db_c3";